// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditOutlinedSvg from "@fishx/icons-svg/es/asn/EditOutlined";
import FishxIcon from '../components/FishxIcon';

var EditOutlined = function EditOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditOutlinedSvg
  }));
};

EditOutlined.displayName = 'EditOutlined';
export default React.forwardRef(EditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EditOutlined.js
// module id = 2589
// module chunks = 0